module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is dedicated to my brother Jay, who (as Jack C. Haldeman II) wrote eight science fiction novels and over a hundred short stories—and also dedicated to. Alaska, where we had the good fortune to live as children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The state is calling itself “our last, best hope” now, which may or may not be true. It is probably the best place to raise a child if for some reason you want him or her to become a science fiction writer. The beauty and size of it, the limitless possibilities. The amazing sky.")]), _vm._v(" "), _c('p', {
    staticClass: "spb"
  }, [_vm._v("I also want to thank the Clutes, John and Judith. John, for clueing me in on the Flammarion novel that eerily parallels this one; Judith, for leading me on a wild bicycle ride through the labyrinthine streets of London, to their huge book collection, where we actually found an English translation of it.")]), _vm._v(" "), _c('p', {
    staticClass: "spb"
  }, [_vm._v("One character’s name was changed to memorialize Gordon R. Dickson, who took many of us to places we wouldn’t have found on our own.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e332cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0